import { Component, OnInit } from '@angular/core';
import { LinkedinModel } from './linkedin.model';
import { LinkedinService } from './linkedin.service';

@Component({
  selector: 'social-linkedin-btn',
  template: `
    <button class="btn btn-block btn-social" (click)="login()" [disabled]="data.isAuth">
    <i class="fa fa-linkedin"></i> {{ data.isAuth? 'CONECTADO' : 'CONECTAR' }}
    </button>
  `,
  styles: [`
    .btn-social{
      margin: 5px;
      padding: 6px 0 6px 12px;
      border: none;
      border-radius: 0;
      background-color: #4875b4 !important;
      color: white !important;
      cursor: pointer;
      position: relative;
      i{
        position: absolute;
        left: 0;
        top: 0;
        padding: 8px;
        background-color: #4169a2 !important;
      }
    }
   
  `]
})
export class LinkedinBtnComponent implements OnInit {
  data: LinkedinModel;

  constructor(private service: LinkedinService) { }

  ngOnInit() {
    this.service.linkedinSubject.subscribe(data => {
      this.data = data;
    });
  }

  login() {
    this.service.loginLinkedin();
  }
}



// WEBPACK FOOTER //
// ./src/app/social/linkedin/linkedin-btn.component.ts